<template>
  <div ref="layout" class="page-query">
    <TableQuery title="人员数据批导" :tools="false" />

    <div class="table-container">
      <TableCommon
        title="批导数据"
        :custome-config="() => vxeShowCustom('xTable')"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
      >
        <template #button>
          <table-button name="download" tip="组织数据批导模版" @click="downloadTemplate('clientOrg', '组织数据批导模版')" />
          <table-button name="download" tip="人员数据批导模版" @click="downloadTemplate('orgPersonImport', '人员数据批导模版')" />
          <table-button name="import" tip="组织数据批导" @click="handleImportExcel('clientOrg')" />
          <table-button
            name="import"
            tip="人员数据批导"
            @click="handleImportExcel('orgPersonImport')"
          />
          <table-button name="save" tip="保存数据" @click="handleSaveImportExcel" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="auto"
          max-height="440"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.gridOptions.columns"
          :data="gridOptions.gridOptions.data"
        >
          <!-- <template #toolbar /> -->
        </vxe-grid>
      </TableCommon>
      <TableCommon title="销售计划单模板上传" :custome-config="() => vxeShowCustom('xTable2')">
        <template #button>
          <el-upload
            ref="upload"
            action=""
            :accept="xls,xlsx"
            :on-change="uploadFilebnew"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" name="upload" tip="新增模板上传" />
          </el-upload>
          <el-upload
            ref="upload"
            action=""
            :on-change="uploadFilebchg"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" name="upload" tip="变更模板上传"   />
          </el-upload>
          <el-upload
            ref="upload"
            action=""
            :on-change="uploadFilesnew"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" name="upload" tip="(公司)新增模板上传"   />
          </el-upload>
          <el-upload
            ref="upload"
            action=""
            :on-change="uploadFileschg"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" name="upload" tip="(公司)变更模板上传"   />
          </el-upload>
          <table-button name="delete" tip="删除" @click="delUpload" />
          <!-- 下载 -->
          <el-dropdown @command="tableEvent">
            <div><table-button name="download" tip="初始模版下载" /></div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in gridOptions2.buttons"
                :key="item.type"
                :command="{
                    icon: 'download',
                    type: item.type,
                    fileName:item.fileName
                  }"
              >{{ item.fileName }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </template>

        <vxe-grid
          ref="xTable2"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions2.columns"
          :data="gridOptions2.data"
        >
          <template #fileName="{row}">
            <span class="blue" @click="dowLoadFile(row)">{{ row.fileName }}</span>
          </template>
          <template #createdDate="{row}">
            <span>{{ row.createdDate || row.creator.createdDate }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

    </div>
  </div>
</template>
<script>
import {
  apiExportExcelTemplate,apiExcelImport,apiGetExcelImportData,apiSaveExcelImportData,
  webUploadFile, deleteFiles,queryFiles,saveHanaUploadFile,deleteHanaAttachment,apiFindAttachBizId,apiAttachmentDownFile
} from '@/api/common'

import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
import { generateUUID } from '@/api/flowHander'
import { download } from '@/utils/frontExport'
export default {
  data() {
    return {
      conditions: {
        templateCode: 'clientOrg',
        batchNumber: ''
      },
      attachPo: {
        fileBizId: '',
        bizCode: '',
        id: ''
      },
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      loading: false,
      gridOptions: {
        buttons: [],
        gridOptions: {
          border: false,
          highlightHoverRow: true,
          resizable: true,
          showOverflow: true,
          height: 'auto',
          maxHeight: '240',
          align: 'center',
          size: 'mini',
          emptyText: '暂时没数据',
          columns: [
            {
              field: 'personCode',
              title: '人员编号',
              width: 100,
              editRender: { name: 'input' }
            },
            {
              field: 'personName',
              title: '人员名称',
              width: 120,
              editRender: { name: 'input' }
            },
            {
              field: 'position',
              title: '岗位',
              width: 130
            },
            {
              field: 'orgCode',
              title: '机构编码',
              width: 110,
              editRender: { name: 'input' }
            },
            {
              field: 'orgName',
              title: '机构名称',
              width: 150,
              editRender: { name: 'input' }
            },
            {
              field: 'parentOrgName',
              title: '父级机构名称',
              width: 120,
              //   visible:false,
              editRender: { name: 'input' }
            },
            {
              field: 'telephone',
              title: '电话',
              width: 100
            },
            {
              field: 'birthDate',
              title: '出生日期',
              width: 120
            },
            {
              field: 'sex',
              title: '性别',
              width: 80
            },
            {
              field: 'address',
              title: '地址',
              width: 180
            },
            {
              field: 'cardNo',
              title: '身份证',
              width: 150
            },
            {
              field: 'marital',
              title: '婚姻',
              width: 80
            },
            {
              field: 'workDate',
              title: '入职日期',
              width: 120
            }
          ],
          data: [],
          editConfig: { trigger: 'click', mode: 'cell' }
        },
        columnsField: 'chanPinMingCheng',
        columnsFields: {
          default: {
            datasource: 'custom',
            defaultVal: '',
            options: [
              { val: '1', label: '选项一', checked: false },
              { val: '2', label: '选项二', checked: false }
            ]
          }
        },
        columnsFieldTypes: { default: '' },
        fieldsEdit: { default: false, chanPinMingCheng: false },
        fields: {
          datasource: 'custom',
          defaultVal: '',
          options: [
            { val: '1', label: '选项一', checked: false },
            { val: '2', label: '选项二', checked: false }
          ]
        },
        display: true,
        init_query: 'N',
        need_page: 'Y',
        indexRow: true,
        page_size: 20
      },
      gridOptions2: {
        buttons: [
          {
            label: '销售计划单新增批导',
            fileName: '销售计划单新增批导模版',
            icon: 'import',
            key: 'V001',
            type: 'orderPlan'
          },
          {
            label: '销售计划单变更批导',
            fileName: '销售计划单变更批导模版',
            icon: 'import',
            key: 'V002',
            type: 'orderPlanChange'
          },
          {
            label: '销售计划(公司/营销单元)批导',
            fileName: '销售计划单(公司/营销单元)批导模版',
            icon: 'import',
            key: 'V003',
            type: 'orderCompanyPlan'
          },
          {
            label: '销售计划(公司/营销单元)变更批导',
            fileName: '销售计划(公司/营销单元)变更批导模版',
            icon: 'import',
            key: 'V004',
            type: 'orderCompanyPlanChange'
          }
        ],
        columns: [
          { type: 'radio', title: '#', filed: 'radio', width: 50 },
          { field: 'id', title: 'id',width: 80 ,visible: false },
          { field: 'bizKindId', title: 'bizKindId',width:80,visible: false  },
          { field: 'bizId', title: 'bizId',visible: false },
          {
            field: 'fileName',
            title: '附件名称',
            slots: { default: 'fileName' }
          },
          {
            field: 'fileKind',
            title: '附件类型'
          },
          {
            field: 'fileSize',
            title: '大小'
          },
          {
            field: 'createdDate',
            title: '上传时间',
            slots: { default: 'createdDate' }
          }
        ],
        data: []
      }

    }
  },
  watch: {
    'gridOptions2.data': {
      handler(val) {
        this.attachPo.attachmentList = val
      },
      deep: true
    }
  },
  created() {
    const params = { bizCode: 'orderPlan,orderPlanChange,orderCompanyPlan,orderCompanyPlanChange' }
    apiFindAttachBizId(params).then(response => {
      this.getFiles(response.data)
    })
  },
  methods: {
    // 模板下崽
    async downloadTemplate(type, fileName) {
      const res = await apiExportExcelTemplate(type)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${fileName}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      // link.target = '_blank'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    conditionChanged(value) {

      this.pagination = {
        page: 1,
        pagesize: 50,
        totalCount: 0
      }
    },
    // 处理分页事件
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.handleQueryImportExcel()
    },
    tableEvent(btn) {
      this.downloadTemplate(btn.type,btn.fileName)
    },
    // 导入excel
    async handleImportExcel(code) {
      // alert(code)
      this.conditions.templateCode = code
      if (code === 'orgPersonImport') {
        this.gridOptions.gridOptions.columns = this.gridOptions.gridOptions.columns.map(v => {
          if (v.field === 'parentOrgName') {
            v.visible = false
            v.width = 150
          }
          if (v.field === 'orgCode') {
            v.width = 110
          }
          if (v.field === 'orgName') {
            v.width = 150
          }
          if (
            v.field === 'personCode' ||
            v.field === 'personName' ||
            v.field === 'position' ||
            v.field === 'telephone' ||
            v.field === 'birthDate' ||
            v.field === 'sex' ||
            v.field === 'marital' ||
            v.field === 'cardNo' ||
            v.field === 'address' ||
            v.field === 'workDate'
          ) {
            v.visible = true
          }
          return v
        })
      } else {
        this.gridOptions.gridOptions.columns = this.gridOptions.gridOptions.columns.map(v => {
          if (v.field === 'parentOrgName') {
            v.visible = true
            v.width = 500
          }
          if (v.field === 'orgCode') {
            v.width = 300
          }
          if (v.field === 'orgName') {
            v.width = 300
          }
          if (
            v.field === 'personCode' ||
            v.field === 'personName' ||
            v.field === 'position' ||
            v.field === 'telephone' ||
            v.field === 'birthDate' ||
            v.field === 'sex' ||
            v.field === 'marital' ||
            v.field === 'cardNo' ||
            v.field === 'address' ||
            v.field === 'workDate'
          ) {
            v.visible = false
          }
          return v
        })
      }
      this.$refs.xTable.refreshColumn()
      // console.log("==dddd=="+JSON.stringify(this.gridOptions.gridOptions.columns))
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: this.conditions.templateCode
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.conditions.batchNumber = res.data
            this.handleQueryImportExcel(res.data)
          }
        })
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      const { page, pagesize } = this.pagination
      const params = { ...this.conditions, page, pagesize }
      const res = await apiGetExcelImportData(params)

      this.gridOptions.gridOptions.data = res.data.Rows
      this.pagination.totalCount = res.data.Total
    },
    // 将导入临时表的数据保存到正式业务表
    async handleSaveImportExcel() {
      if (!this.gridOptions.gridOptions.data.length) return this.$message.warning('没有可保存的数据！')
      const formData = new FormData()
      const { batchNumber, templateCode } = this.conditions
      formData.append('batchNumber', batchNumber)
      formData.append('templateCode', templateCode)
      const res = await apiSaveExcelImportData(formData)
      if (res.status === 1) {
        this.$message.success('保存成功!')
      }
    },
    async dowLoadFile({ file_id, id, fileName }) {
      const res = await apiAttachmentDownFile({ id: file_id || id })
      download(res.data, fileName)
    },
     async getFiles(bizId) {
      if (bizId.indexOf(',') !== -1) {
        const txtArr = bizId.split(',')
        for (var i = 0; i < txtArr.length; i++) {
          const strArr = txtArr[i].split(':')
          const params = {bizId: strArr[0], bizCode: strArr[1]}
          if (strArr[0] !== '') {
            const {data} = await queryFiles(params)
            //alert('id=='+strArr[0]+'===')
           // data.push('id',strArr[0])
            //alert(data.bizKindId)
            this.gridOptions2.data.unshift(...data)
            this.$set(this['gridOptions2'], 'id', strArr[0])
          }
        }
      } else {
        const strArr = bizId.split(':')
        const params = { bizId: strArr[0], bizCode: strArr[1]}
        if (bizId !== '') {
          const {data} = await queryFiles(params)
         //alert(data.id)
         // alert(data.bizKindId)
          this.gridOptions2.data = data
        }
      }
    },
    // 删除附件
    async delUpload(type) {
      const check = this.$refs.xTable2.getRadioRecord()
     // alert(check.id)
      const index = this.gridOptions2.data.findIndex(v => v._X_ID === check._X_ID)
      await deleteFiles({ id: check.file_id || check.id, isCheck: false })
      await deleteHanaAttachment({ bizCode: check.bizKindId, id: check.id||check.file_id })
      this.gridOptions2.data.splice(index, 1)
    },
    async uploadFileCommon(file) {
      const formData = new FormData()
      await generateUUID().then(res => {
        this.attachPo.fileBizId = res.data
      })
      formData.append('bizId', this.attachPo.fileBizId)
      formData.append('bizCode', this.attachPo.bizCode)
      formData.append('formSecretLevel', 0)
      formData.append('name', file.name)
      formData.append('type', file.raw.type)
      formData.append('lastModifiedDate', file.raw.lastModifiedDate)
      formData.append('size', file.size)
      formData.append('file', file.raw)

      this.attachPo.name= file.name
      this.attachPo.size= file.size
      this.attachPo.type= file.raw.type
      const { data } = await webUploadFile(formData)
      this.attachPo.path= data.path
      this.attachPo.id= data.id
      const { data2 } = await saveHanaUploadFile(this.attachPo)
      data.file_id = data.id
      data.bizKindId=this.attachPo.bizCode
      delete data.id
      this.gridOptions2.data.unshift(data)
    },
    async uploadFilebnew(file) {
      this.attachPo.bizCode='orderPlan'
      if (file.name !== '销售计划单新增批导模版.xlsx') {
        this.$message.error("上传文件不是'销售计划单新增批导模版'！")
      } else {
        this.uploadFileCommon(file)
      }
    },
    async uploadFilebchg(file) {
      this.attachPo.bizCode='orderPlanChange'
      if (file.name !== '销售计划单变更批导模版.xlsx') {
        this.$message.error("上传文件不是'销售计划单变更批导模版'！")
      } else {
        this.uploadFileCommon(file)
      }
    },
    async uploadFilesnew(file) {
      this.attachPo.bizCode='orderCompanyPlan'
      if (file.name !== '销售计划单(公司_营销单元)批导模版.xlsx') {
        this.$message.error("上传文件不是'销售计划单(公司_营销单元)批导模版！")
      } else {
        this.uploadFileCommon(file)
      }
    },
    async uploadFileschg(file) {
      this.attachPo.bizCode='orderCompanyPlanChange'
      if (file.name !== '销售计划(公司_营销单元)变更批导模版.xlsx') {
        this.$message.error("上传文件不是'销售计划(公司_营销单元)变更批导模版'！")
      } else {
        this.uploadFileCommon(file)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/client-manage/personImport.vue